import {Component} from 'react';
import {Grid} from 'semantic-ui-react';
import PropTypes from 'prop-types';

export default class TitleLegalDescription extends Component {
  static propTypes = {
    className: PropTypes.string,
    legalDescription: PropTypes.object.isRequired,
  };

  render() {
    const {className, legalDescription} = this.props;
    const classNames = ['title-legal-description', className].join(' ').trim();

    return (
      <div className={classNames}>
        <Grid>
          <Grid.Row>
            <Grid.Column className="left" width={4}>
              <strong>Estate</strong>
            </Grid.Column>
            <Grid.Column width={12}>
              {legalDescription.estateType ? legalDescription.estateType : '-'}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="left" width={4}>
              Area
            </Grid.Column>
            <Grid.Column width={12}>
              {legalDescription.totalArea ? (legalDescription.totalArea * 10000).toFixed(2) + ' m²' : '-'}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="left" width={4}>
              Legal Description
            </Grid.Column>
            <Grid.Column width={12}>
              {legalDescription.description ? legalDescription.description : '-'}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column className="left" width={4}>
              Parcel Share
            </Grid.Column>
            <Grid.Column width={12}>
              {legalDescription.estateShare ? legalDescription.estateShare : '-'}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}